// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"393":"7794686f","453":"4c207b1e","647":"b77b3fb6"}[chunkId] + ".chunk.js";
};